export default __webpack_public_path__ + "src/components/pages/login/cf69abb55752dcf3ad4435f832789bcf.png";